class ArgumentError extends Error {
  constructor(argument: string) {
    super(`The argument '${argument}' is invalid`);
  }
}

export default ArgumentError;
